const canUseDOM = (typeof(window) !== `undefined` && window != null && window.document != null && window.document.createElement != null)

// mock default client for server-side rendering
const sswindow = {
  addEventListener: () => {},
  removeEventListener: () => {},
  localStorage: {},
  sessionStorage: {},
  document: {
    documentElement: {
      clientWidth: 1024,
      clientHeight: 768,
    },
  },
}
const window2 = (canUseDOM? window: sswindow)
const document2 = (canUseDOM? window.document: sswindow.document)

export {canUseDOM, window2 as window, document2 as document}



// WEBPACK FOOTER //
// ./src/app/exec-env.js